/*
  Site header behaviour (sections/me-header.liquid):
  - .is-scrolled once the page moves, for the frosted bar
  - phone menu: open/close, Escape, lock page scroll, close when a link is tapped
*/
(function () {
  function wire(root) {
    var header = root.querySelector('[data-me-header]');
    if (!header || header.dataset.wired) { return; }
    header.dataset.wired = '1';

    var toggle = header.querySelector('[data-me-header-toggle]');
    var menu = header.querySelector('[data-me-header-menu]');
    var bar = header.querySelector('.mhd__bar');

    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    function setOpen(open) {
      if (!toggle || !menu) { return; }
      header.style.setProperty('--mhd-h', bar.getBoundingClientRect().bottom + 'px');
      menu.hidden = !open;
      header.classList.toggle('is-open', open);
      document.body.classList.toggle('mhd-lock', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        var first = menu.querySelector('a');
        if (first) { first.focus({ preventScroll: true }); }
      } else {
        toggle.focus({ preventScroll: true });
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
    }
    if (menu) {
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) { setOpen(false); } });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-open')) { setOpen(false); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900 && header.classList.contains('is-open')) { setOpen(false); }
    });
  }

  function run() { wire(document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();
